// extracted by css-extract-rspack-plugin
export default {"settlementQuotaConfig":"settlementQuotaConfig-k9wlZu","rightTable":"rightTable-UxfMDB","rightTableTop":"rightTableTop-egnK_v"};